@let config = this.config();

<ng-template let-color="color" #messageTemplate>
  <div [class]="'flex flex-row justify-between w-full sm:max-w-[50vw] p-2 gap-2 rounded bg-surface border border-l-8 border-'+color+' shadow-lg'">
    <div class="flex flex-row gap-2">
      <div [class]="'h-full'">
        <soft-icon [name]="icon()" [class]="`text-${color}`"></soft-icon>
      </div>
      <div class="flex flex-col">
        <span class="font-bold text-sm">{{title()}}</span>
        <span class="text-xs text-light">{{message()}}</span>
      </div>
    </div>
    @if (config.dismiss !== false) {
      <div class="pointer text-light hover:text-color"
           (click)="onDismiss(config.id, config.onDismiss)">
        <soft-icon name="fa-regular fa-xmark"></soft-icon>
      </div>
    }
  </div>
</ng-template>

@switch(config.type) {
  @case ('success') {
    <ng-container *ngTemplateOutlet="messageTemplate; context: {color: 'success'}"></ng-container>
  }
  @case ('warning') {
    <ng-container *ngTemplateOutlet="messageTemplate; context: {color: 'warning'}"></ng-container>
  }
  @case ('error') {
    <ng-container *ngTemplateOutlet="messageTemplate; context: {color: 'danger'}"></ng-container>
  }
  @case ('info') {
    <ng-container *ngTemplateOutlet="messageTemplate; context: {color: 'info'}"></ng-container>
  }
  @case ('loading') {
    <ng-container *ngTemplateOutlet="messageTemplate; context: {color: 'info'}"></ng-container>
  }
  @case ('saving') {
    <ng-container *ngTemplateOutlet="messageTemplate; context: {color: 'info'}"></ng-container>
  }
}
